import { render, staticRenderFns } from "./editInvoicing.vue?vue&type=template&id=2fea6f24&scoped=true"
import script from "./editInvoicing.vue?vue&type=script&lang=js"
export * from "./editInvoicing.vue?vue&type=script&lang=js"
import style0 from "./editInvoicing.vue?vue&type=style&index=0&id=2fea6f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fea6f24",
  null
  
)

export default component.exports